jQuery(function ($) {


    var height = $(window).height();
    var header = $('.l-header');
    var headerHeight = header.outerHeight();
    var topBtn = $('.p-fixed-btn');


    var target = $(".p-product-tab");
    var targetHeight = target.outerHeight();
    var offsetTop = target.offset().top; // 要素の初期位置を取得
    var placeholder = $("<div>").css("height", targetHeight); // レイアウト崩れ防止

    
    // ================================================================
    // サイズガイド：モーダル
    // ================================================================
    $('.js-modal').on('click', function () {
        $('.p-modal').fadeIn();
        $('.p-modal__close , .p-modal__bg').click(function () {
            $('.p-modal').fadeOut();
        });
    });
    
    // ================================================================
    // アコーディオン
    // ================================================================
    $(function () {
        $(".js-accordion-title").on("click", function () {
            $(this).next().slideToggle(300);
            $(this).toggleClass("open", 300);
        });
    });
    document.addEventListener('shopify:section:load', (event) => {
        $(function () {
            $(".js-accordion-title").each(function () {
                var $title = $(this);
                var $body = $title.next(".c-accordion__body");
    
                // Shopifyカスタマイズ画面で選択されたブロックかどうかを判定
                if ($title.closest('.p-accordion___item').is(event.target)) {
                    $body.show(); // 初期状態で開く
                    $title.addClass("open"); // クラスを付与
                } else {
                    $body.hide(); // それ以外は閉じる
                    $title.removeClass("open");
                }
    
                // クリック時のトグル動作
                $title.off("click").on("click", function () {
                    $(this).next().slideToggle(300);
                    $(this).toggleClass("open", 300);
                });
            });
        });
    });
    
    // Shopifyのカスタマイズ画面でブロックが選択されたときに開く
    document.addEventListener('shopify:block:select', function(event) {
        $(".js-accordion-title").each(function () {
            var $title = $(this);
            var $body = $title.next(".c-accordion__body");
    
            if ($title.closest('.p-accordion___item').is(event.target)) {
                $body.slideDown(300); // 開く
                $title.addClass("open");
            } else {
                $body.slideUp(300); // 閉じる
                $title.removeClass("open");
            }
        });
    });
    



});

// ================================================================
// ページ内アンカーのページ付きリンクへのスムーススクロール
// ================================================================
// document.addEventListener("DOMContentLoaded", function () {
//     function smoothScroll(){
//         const links = document.querySelectorAll('a[href^="#"]');

//         links.forEach((link) =>{
//         link.addEventListener('click', (e) => {
//             e.preventDefault();
            
//             const href = link.getAttribute('href');
//             const targetSection = document.querySelector(href);
//             const sectionTop = targetSection.getBoundingClientRect().top;
//             const currentPos = window.scrollY;
//             const gap = 170;
//             const target = sectionTop + currentPos - gap;

//             window.scrollTo({
//             top: target,
//             behavior: 'smooth',
//             });
//         });
//         });
//     }
//     smoothScroll();
//     document.addEventListener("shopify:section:load", function () {
//         smoothScroll();
//     });
// });
document.addEventListener("DOMContentLoaded", function () {
        console.log('現在時刻',now);
    console.log('販売開始',data-start);
    console.log('販売終了',data-end);

    function smoothScroll() {
        // クラス 'js-smooth-scroll' を持つアンカーリンクのみを対象とする
        const links = document.querySelectorAll('a.js-smooth-scroll[href^="#"]');

        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                
                const href = link.getAttribute('href');
                const targetSection = document.querySelector(href);
                
                // ターゲット要素が存在する場合のみ処理を実行
                if (targetSection) {
                    const sectionTop = targetSection.getBoundingClientRect().top;
                    const currentPos = window.scrollY;
                    const gap = 66;
                    const target = sectionTop + currentPos - gap;

                    window.scrollTo({
                        top: target,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }
    
    smoothScroll();
    
    document.addEventListener("shopify:section:load", function () {
        smoothScroll();
    });
});


// ================================================================
// 該当セクションに入るときタブに黒線を追加
// ================================================================
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll(".l-sec"); // 監視対象のセクション
    const tabLinks = document.querySelectorAll(".p-product-tab__link"); // ナビゲーションのリンク

    // 1. `.p-product-tab__link` の `href` から `#` を取り除き、対応するリンクをマッピング
    const linkMap = new Map();
    tabLinks.forEach(link => {
        const targetId = link.getAttribute("href").replace("#", ""); // `#` を削除
        if (targetId) {
            linkMap.set(targetId, link); // { "flow" => <a href="#flow"> }
        }
    });

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionId = entry.target.id; // セクションの ID を取得

                // 2. `.p-product-tab__link` に `active` クラスを付与・削除
                tabLinks.forEach(link => link.classList.remove("section__active")); // すべてのリンクの `active` を削除
                if (linkMap.has(sectionId)) {
                    linkMap.get(sectionId).classList.add("section__active"); // 一致するリンクに `active` クラスを追加
                    // console.log(`セクション ${sectionId} の対応するタブがアクティブになりました！`);
                }
            }
        });
    }, {
        root: null,  // ビューポート基準
        rootMargin: "-50% 0px -50% 0px", // セクションの上端が画面上部に達したら発火
        threshold: 0 // 1pxでも入ったら反応
    });

    // 3. `.l-sec` の要素を監視
    sections.forEach(section => observer.observe(section));
});

// ================================================================
// タブ
// ================================================================

document.addEventListener("DOMContentLoaded", function () {

    function initializeProductSelection() {
        const mySwiper_thumb = new Swiper('.p-product__thumb-swiper', {
            speed: 600,
            centerInsufficientSlides: true,
            slidesPerView: 7,
            spaceBetween: 4,
            pagination: {
                el: '.swiper-pagination', // ページネーション要素のクラス
                clickable: true, // クリックによるスライド切り替えを有効にする
                type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
            },
            // navigation: {
            //     nextEl: '.p-product__thumb-swiper-wrapper .swiper-button-next',
            //     prevEl: '.p-product__thumb-swiper-wrapper .swiper-button-prev',
            // },
            breakpoints: {
                769: {
                    slidesPerView: 9,
                    spaceBetween: 11,
                }
            },
        });

        const mySwiper_main = new Swiper('.p-product__main-swiper', {
            speed: 600,
            centeredSlides: false,
            slidesPerView: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: '.p-product__thumb-swiper-wrapper .swiper-button-next',
                prevEl: '.p-product__thumb-swiper-wrapper .swiper-button-prev',
            },
            thumbs: {
                swiper: mySwiper_thumb,
            },
            breakpoints: {
                1680: {
                    slidesPerView: 1, // 1680px以上で変更される
                }
            }
        });


        // タブコンテンツ取得
        const tabColor = document.getElementById("tab1");
        const tabSize = document.getElementById("tab2");
        const tabCompensation = document.getElementById("tab3");

        // オプション選択取得
        const colorRadios = document.querySelectorAll("input[name='color']");
        const sizingRadios = document.querySelectorAll("input[name='sizing']");
        const sizeRadiosId = document.getElementById("size");
        const sizeRadios = document.querySelectorAll("input[name='size']");
        const compensationRadios = document.querySelectorAll("input[name='compensation']");

        // ボタン取得
        const buttonContainer = document.getElementById("next-btn-container");
        const nextButtonTabSecond = document.getElementById("next-btn-tab2");
        const nextButtonTabThird = document.getElementById("next-btn-tab3");
        const checkoutButton = document.getElementById("checkout-btn");
        const resetButton = document.getElementById("reset-btn");
        const fixedBtn = document.getElementById("p-fixed-btn");
        const fixedCheckoutButton = document.getElementById("p-fixed-checkout-btn");
        
        const selectedColorValue = document.getElementById("selected-color");

        // 商品データの取得
        const variantMainDataElement = document.getElementById("main-variant-data");
        if (!variantMainDataElement) {
            // console.error("エラー: #variant-data が見つかりません！");
            return;
        }
        const variantMainData = JSON.parse(variantMainDataElement.textContent);

        const variantSubDataElement = document.getElementById("sub-variant-data");
        if (!variantSubDataElement) {
            // console.error("エラー: #variant-data が見つかりません！");
            return;
        }
        const variantSubData = JSON.parse(variantSubDataElement.textContent);
// ページロード時にセッションストレージに保存された値があるかチェック
const savedColor = sessionStorage.getItem("selectedColor");
        
if (savedColor) {
    // 保存された色があれば、その色を選択
    const savedColorRadio = Array.from(colorRadios).find(radio => radio.value === savedColor);
    if (savedColorRadio && !savedColorRadio.disabled) {
        savedColorRadio.checked = true;
        moveSlide(savedColorRadio);
        updateSizeAvailability();
        updateColorAvailability();
        nextButtonTabSecond.disabled = false;
    } else {
        // 保存された色が無効な場合は最初の有効な色を選択
        selectFirstAvailableColor();
    }
} else {
    // 保存された色がない場合は最初の有効な色を選択
    selectFirstAvailableColor();
}
updateColorAvailability();

 // ------------ サイズノート表示切り替え機能 ------------ 
    function updateSizeNoteVisibility() {
        const kitRadio = document.getElementById("kit");
        const sizeSelectionRadio = document.getElementById("select");
        const sizeRadios = document.querySelectorAll('input[name="size"]');
        
        // 各p-size__text-noteを取得
        const kitNote = document.querySelector('#kit').closest('.p-product__size').querySelector('.p-size__text-note');
        const sizeNote = document.querySelector('#select').closest('.p-product__size').querySelector('.p-size__text-note');
        
        if (!kitNote || !sizeNote) return;
        
        // 初期状態の設定
        if (kitRadio && kitRadio.checked) {
            // サイジングキットが選択されている場合
            kitNote.style.display = 'block';
            sizeNote.style.display = 'none';
        } else if (sizeSelectionRadio && sizeSelectionRadio.checked) {
            // サイズ選択が選択されている場合
            kitNote.style.display = 'none';
            sizeNote.style.display = 'block';
        } else {
            // どちらも選択されていない場合はデフォルト
            kitNote.style.display = 'none';
            sizeNote.style.display = 'none';
        }
    }
    
    // サイジングキットのラジオボタンにイベントリスナーを追加
    const kitRadio = document.getElementById("kit");
    if (kitRadio) {
        kitRadio.addEventListener("change", function() {
            updateSizeNoteVisibility();
        });
    }
    
    // 「サイズを選択してください」のラジオボタンにイベントリスナーを追加
    const sizeSelectionRadio = document.getElementById("select");
    if (sizeSelectionRadio) {
        sizeSelectionRadio.addEventListener("change", function() {
            updateSizeNoteVisibility();
        });
    }
    
    // 個別のサイズラジオボタンにもイベントリスナーを追加
    sizeRadios.forEach(radio => {
        radio.addEventListener("change", function() {
            // サイズが選択されたら「サイズ選択」ラジオも自動的にONになるので
            // その後にノート表示を更新
            setTimeout(() => {
                updateSizeNoteVisibility();
            }, 10);
        });
    });
updateSizeNoteVisibility();

function selectFirstAvailableColor() {
    const firstAvailableColor = Array.from(colorRadios).find(radio => !radio.disabled);
    if (firstAvailableColor) {
        firstAvailableColor.checked = true;
        moveSlide(firstAvailableColor);
        updateSizeAvailability();
        // 最初の色を選択した時点では次のボタンは無効のままにする
        // nextButtonTabSecond.disabled = false;
        saveSelectionToStorage();
    }
}

        // ------------ ボタンをクリック ------------ 
        nextButtonTabSecond.addEventListener("click", function (event) {
            handleTabClick("tab2");
            // Tab2へ進む場合はサイズ一覧を必ず展開
            if (typeof sizeRadiosId !== 'undefined' && sizeRadiosId) {
                sizeRadiosId.style.display = 'block';
            }
            fixedBtn.textContent = 'サイズ選択に戻る';
            selectedColorValue.style.display = 'flex';
            smoothScrollTo('.p-product__tabs', headerOffset + 10);
        });
        nextButtonTabThird.addEventListener("click", function (event) {
            handleTabClick("tab3");
        });
        resetButton.addEventListener("click", function (event) {
            resetAll();
            smoothScrollTo('.p-product__tabs', headerOffset + 10);
        });

        // タブ見出しクリック時の挙動はデフォルト（既存実装）のままとする

        // console.log("サイジング",sizingRadios);

        // ------------ radio選択でボタンを有効化 ------------ 

        colorRadios.forEach(radio => {
            radio.addEventListener("change", function (event) {
                nextButtonTabSecond.disabled = false
                // console.log("ボタンが有効化");
                moveSlide(event.target);
                // add function
                updateSizeAvailability();
                saveSelectionToStorage();
            });
        });
        sizingRadios.forEach(radio => {
            radio.addEventListener("change", function () {
                // console.log("2個目のボタンが有効化");

                if(tabCompensation !== null){
                    if (this.value !== "サイズ選択") {
                        nextButtonTabThird.disabled = false;
                        sizeRadiosId.style.display = "none";
                        fixedBtn.style.display = 'none';
                        fixedCheckoutButton.style.display = 'block';
                        resetSizeRadios();
                    }
                    else{
                        nextButtonTabThird.disabled = true;
                        sizeRadiosId.style.display = "block";
                        fixedBtn.style.display = 'block';
                        fixedCheckoutButton.style.display = 'none';
                    }
                }else{
                    if (this.value !== "サイズ選択") {
                        checkoutButton.classList.remove("disabled");
                        sizeRadiosId.style.display = "none";
                        fixedBtn.style.display = 'none';
                        fixedCheckoutButton.style.display = 'block';
                        resetSizeRadios();
                    }
                    else{
                        checkoutButton.classList.add("disabled");
                        sizeRadiosId.style.display = "block";
                        fixedBtn.style.display = 'block';
                        fixedCheckoutButton.style.display = 'none';
                    }
                }
                saveSelectionToStorage();
                updateCheckoutUrl();
            });
        });

        sizeRadios.forEach(radio => {
            radio.addEventListener("change", function () {

                // ★ サイズを選んだら、「サイズを選択してください」ラジオを自動ON
                const sizeSelectionRadio = Array.from(sizingRadios).find(r => r.value === "サイズ選択");
                if (sizeSelectionRadio && !sizeSelectionRadio.checked) {
                    sizeSelectionRadio.checked = true;
                    // 念のため、サイズ一覧は開いたままにする
                    if (sizeRadiosId) sizeRadiosId.style.display = "block";
                    // ※ ここでは sizingRadios の change イベントは発火させない
                    //    （発火させると一瞬「支払いへ進む」が隠れるUIが走るため）
                }

                if(tabCompensation !== null){
                    nextButtonTabThird.disabled = false;
                    fixedBtn.style.display = 'none';
                    fixedCheckoutButton.style.display = 'block';
                }else{
                    checkoutButton.classList.remove("disabled");
                    fixedBtn.style.display = 'none';
                    fixedCheckoutButton.style.display = 'block';
                }
                saveSelectionToStorage();
                updateCheckoutUrl();
            });
        });


         // ------------ 価格の更新関数 ------------
         function changePrice() {
            // // 価格表示要素
            // const mainPriceElement = document.querySelector('.p-product__main-price');
            // const beforePriceElement = document.querySelector('.p-product__before-price');
            
            // // カラーラジオボタン
            // const colorRadios = document.querySelectorAll('input[name="color"]');
            
            // // 各カラーラジオボタンにイベントリスナーを追加
            // colorRadios.forEach(radio => {
            // radio.addEventListener('change', updateProductPrice);
            // });
            
            // // 初期読み込み時に選択されているカラーの価格を設定
            // const initialSelectedColor = document.querySelector('input[name="color"]:checked');
            // if (initialSelectedColor) {
            // updateProductPrice({ target: initialSelectedColor });
            // }
            
            // // 価格更新関数
            // function updateProductPrice(event) {
            // // 選択されたラジオボタン
            // const selectedRadio = event.target;
            
            // // 対応する価格要素を取得
            // const priceContainer = selectedRadio.closest('.p-radio').querySelector('.p-radio__price');
            
            // if (priceContainer) {
            //     // 通常価格と割引価格の取得
            //     const salePrice = priceContainer.querySelector('.sale-price');
            //     const linePrice = priceContainer.querySelector('.line-price');
            //     const regularPrice = priceContainer.querySelector('.p-radio__after-price:not(.sale-price):not(.line-price)');
                
            //     // 価格表示の更新
            //     if (salePrice && linePrice) {
            //     // 割引がある場合
            //     mainPriceElement.innerHTML = salePrice.innerHTML;
            //     beforePriceElement.style.display = 'block';
            //     beforePriceElement.innerHTML = `<s>${linePrice.innerHTML}</s>`;
            //     } else if (regularPrice) {
            //     // 割引がない場合
            //     mainPriceElement.innerHTML = regularPrice.innerHTML;
            //     beforePriceElement.style.display = 'none';
            //     }
            // }
            // }
            // 価格表示要素
            const mainPriceElement = document.querySelector('.p-product__main-price');
            const beforePriceElement = document.querySelector('.p-product__before-price');

            // 割引ラベルの要素
            const saleLabel = document.querySelector('.p-product__price-label_sale');
            
            // 既存の選択中カラー表示要素を取得
            const selectedColorDisplay = document.querySelector('.p-product__selected-color');
            const selectedColorSpan = selectedColorDisplay ? selectedColorDisplay.querySelector('span') : null;
            
            // カラーラジオボタン
            const colorRadios = document.querySelectorAll('input[name="color"]');
            
            // 各カラーラジオボタンにイベントリスナーを追加
            colorRadios.forEach(radio => {
                radio.addEventListener('change', updateProductPrice);
            });
            
            // 初期読み込み時に選択されているカラーの価格を設定
            const initialSelectedColor = document.querySelector('input[name="color"]:checked');
            if (initialSelectedColor) {
                updateProductPrice({ target: initialSelectedColor });
            }
            
            // 価格更新関数
            function updateProductPrice(event) {
                // 選択されたラジオボタン
                const selectedRadio = event.target;
                
                // 選択されたカラー名を取得
                const colorName = selectedRadio.value;
                
                // 選択中のカラー表示を更新
                if (selectedColorSpan) {
                selectedColorSpan.textContent = colorName;
                }
                
                // 対応する価格要素を取得
                const priceContainer = selectedRadio.closest('.p-radio').querySelector('.p-radio__price');
                
                if (priceContainer) {
                // 通常価格と割引価格の取得
                const salePrice = priceContainer.querySelector('.sale-price');
                const linePrice = priceContainer.querySelector('.line-price');
                const regularPrice = priceContainer.querySelector('.p-radio__after-price:not(.sale-price):not(.line-price)');

                // 割引率を計算する関数
                function extractPrice(source) {
                  if (source == null) return null; // null/undefined ガード
                  // DOM 要素なら innerText、文字列ならそのまま
                  const text = typeof source === 'string'
                    ? source
                    : source.innerText || source.textContent || '';
                  // 正規表現で ¥ の後ろに続くカンマ区切り数字を抽出
                  const m = text.match(/¥\s*([\d,]+)/);
                  return m ? Number(m[1].replace(/,/g, '')) : null;
                }
                  
                // 価格表示の更新
                if (salePrice && linePrice) {
                  // 割引がある場合
                  mainPriceElement.innerHTML = salePrice.innerHTML + '<span style="font-size:16px"> (税込)</span>';
                  beforePriceElement.style.display = 'block';
                  beforePriceElement.innerHTML = `<s>${linePrice.innerHTML}</s>`;
                  // セールラベルを書き換え＆表示
                  const priceRegular = extractPrice(linePrice); // 割引前価格
                  const priceSale = extractPrice(salePrice);     // 割引後価格
                  const saleRate = Math.round(((priceRegular-priceSale) / priceRegular) * 100);
                  saleLabel.innerHTML = saleRate + "%OFF";
                  saleLabel.style.display = 'inline-block';
                } else if (regularPrice) {
                  // 割引がない場合
                  mainPriceElement.innerHTML = regularPrice.innerHTML + '<span style="font-size:16px"> (税込)</span>';
                  beforePriceElement.style.display = 'none';
                  saleLabel.style.display = 'none';
                }
              }
            }
        }
        changePrice();
        document.addEventListener("shopify:section:load", function () {
            changePrice();
        });
        // ------------ タブ切り替わり後に上部へスクロール ------------
        function smoothScrollTo(target, offset = 0, duration = 500) {
        // 文字列（セレクタ）の場合は要素を取得
        const targetElement = typeof target === 'string' ? document.querySelector(target) : target;
        
        // ターゲット要素が存在しない場合は処理を終了
        if (!targetElement) {
            console.warn('スクロール先の要素が見つかりません:', target);
            return;
        }
        
        // ターゲット要素の位置を取得（ページ上部からの距離）
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        
        // オフセットを適用した最終的なスクロール位置
        const targetOffset = targetPosition - offset;
        
        // 現在のスクロール位置
        const startPosition = window.pageYOffset;
        
        // スクロールする距離
        const distance = targetOffset - startPosition;
        
        // アニメーション開始時間
        let startTime = null;
        
        // スクロールアニメーション関数
        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            
            // イージング関数（ease-in-out）
            const easeInOut = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            
            // スクロール位置を計算して設定
            window.scrollTo(0, startPosition + distance * easeInOut(progress));
            
            // アニメーションが完了していなければ続行
            if (timeElapsed < duration) {
            requestAnimationFrame(animation);
            }
        }
        
        // アニメーション開始
        requestAnimationFrame(animation);
        }
        

        function addScrollButtonListener(buttonSelector, targetSelector, offset = 0) {
        const button = document.querySelector(buttonSelector);
        
        if (!button) {
            console.warn('ボタンが見つかりません:', buttonSelector);
            return;
        }
        
        button.addEventListener('click', function(event) {
            // デフォルトのリンク動作を防止
            event.preventDefault();
            
            // 指定された要素へスムーススクロール
            smoothScrollTo(targetSelector, offset);
        });
        }
        const headerOffset = document.querySelector('.l-header') ? document.querySelector('.l-header').offsetHeight : 0;

		// ------------ サイズ表示順の整列（号数順） ------------
		// 想定される値：
		//  - 「サイジングキット」
		//  - 「◯号」
		//  - 「◯号:△△」
		//  ルール：サイジングキットは最上部、その他は号数（整数）昇順
		function sortSizeOptionsByGou() {
			// サイズ選択のボタン群（ラベル群）
			const btnContainer = document.querySelector('.p-radio-sizing__btns');
			if (!btnContainer) return;

			const labels = Array.from(btnContainer.querySelectorAll('label'));
			if (labels.length <= 1) return;

			function getKeyFromValue(value) {
				const v = String(value || '');
				// サイジングキットは常に先頭
				if (v.includes('サイジングキット')) {
					return { group: 0, num: -1, raw: v };
				}
				// 「◯号」または「◯号:△△」から号数を抽出
				const m = v.match(/(\d+)\s*号/);
				const num = m ? parseInt(m[1], 10) : Number.POSITIVE_INFINITY;
				return { group: 1, num, raw: v };
			}

			labels.sort((a, b) => {
				const aInput = a.querySelector('input[name="size"]');
				const bInput = b.querySelector('input[name="size"]');
				const ka = getKeyFromValue(aInput ? aInput.value : '');
				const kb = getKeyFromValue(bInput ? bInput.value : '');
				if (ka.group !== kb.group) return ka.group - kb.group;
				if (ka.num !== kb.num) return ka.num - kb.num;
				return ka.raw.localeCompare(kb.raw, 'ja');
			});

			// 並べ替え（DOMを移動）
			labels.forEach(label => btnContainer.appendChild(label));
		}

        // ------------ サイズの在庫状況チェック機能 ------------
        // 選択されたカラーに対して各サイズの在庫状況を更新する関数
        function updateSizeAvailability() {
            const selectedColor = document.querySelector('input[name="color"]:checked')?.value;
            if (!selectedColor) return;
            
            // console.log("選択されたカラー:", selectedColor);
            
            // サイズラジオボタンを取得
            const sizeRadios = document.querySelectorAll('input[name="size"]');
            const sizingRadios = document.querySelectorAll('input[name="sizing"]');

            // カラー×サイズのバリアントが「存在」するか（在庫有無は問わない）
            function variantExists(colorValue, sizeValue) {
                return variantMainData.some(v => v.option1 === colorValue && v.option2 === sizeValue);
            }

            // 各サイズの在庫状況をチェック
            sizeRadios.forEach(sizeRadio => {
                const sizeValue = sizeRadio.value;
                const sizeLabel = sizeRadio.parentElement;
                if (!sizeLabel) return;

                // 既存のSold Outメッセージがあれば削除
                const existingSoldOut = sizeLabel.querySelector('.size-sold-out');
                if (existingSoldOut) existingSoldOut.remove();

                // ✅ バリアント自体が存在しないサイズは、一覧から非表示（カラー毎に表示サイズを切り替える）
                if (!variantExists(selectedColor, sizeValue)) {
                    // 選択されていたら解除
                    if (sizeRadio.checked) {
                        sizeRadio.checked = false;
                        sessionStorage.removeItem('selectedSize');
                    }
                    sizeRadio.disabled = true;
                    sizeLabel.classList.remove('is-disabled');
                    sizeLabel.style.display = 'none';
                    return;
                }

                // 存在するサイズは表示
                sizeLabel.style.display = '';

                // 選択された色とサイズの組み合わせで在庫があるかチェック
                const stockStatus = checkVariantAvailability(selectedColor, sizeValue);

                if (stockStatus.saleDisable || !stockStatus.available) {
                    // 在庫がない場合はSold Outメッセージを追加
                    sizeRadio.disabled = true;
                    sizeLabel.classList.add('is-disabled');
                    const soldOutSpan = document.createElement('span');
                    soldOutSpan.classList.add('size-sold-out');
                    soldOutSpan.innerHTML = String(stockStatus.soldOutText || 'Sold Out').replace(/\n/g, '<br>');
                    sizeLabel.appendChild(soldOutSpan);
                } else {
                    // 在庫がある場合は有効化
                    sizeRadio.disabled = false;
                    sizeLabel.classList.remove('is-disabled');
                }
            });
            // サイジングキットの在庫状況をチェック
            sizingRadios.forEach(sizingRadio => {
                // サイズ選択ラジオボタンはスキップ
                if (sizingRadio.value === "サイズ選択") return;
                
                const sizingValue = sizingRadio.value;
                const sizingLabel = sizingRadio.closest('.p-radio-size'); // 親要素を取得
                
                if (!sizingLabel) return;
                
                // 既存のSold Outメッセージがあれば削除
                const existingSoldOut = sizingLabel.querySelector('.size-sold-out');
                if (existingSoldOut) {
                    existingSoldOut.remove();
                }
                
                // サイジングキットの在庫状況をチェック（カラーと組み合わせる）
                const stockStatus = checkVariantAvailability(selectedColor, sizingValue);
                
                if (stockStatus.saleDisable || !stockStatus.available) {
                    // 在庫がない場合はSold Outメッセージを追加
                    sizingRadio.disabled = true;
                    sizingLabel.classList.add('is-disabled');
                    const soldOutSpan = document.createElement('span');
                    soldOutSpan.classList.add('size-sold-out');
                    // SKU（バリアント）毎に設定された soldout_button_text を反映
                    soldOutSpan.innerHTML = String(stockStatus.soldOutText || 'Sold Out').replace(/\n/g, '<br>');
                    
                    // サイジングキットの場合はラベル内の適切な位置に追加
                    const imgContainer = sizingLabel.querySelector('.p-radio__img');
                    if (imgContainer) {
                        imgContainer.appendChild(soldOutSpan);
                    } else {
                        sizingLabel.appendChild(soldOutSpan);
                    }
                } else {
                    // 在庫がある場合は有効化
                    sizingRadio.disabled = false;
                    sizingLabel.classList.remove('is-disabled');
                }
            });

	            // サイズ表示順を号数順に整列（サイジングキットは最上部）
	            sortSizeOptionsByGou();

            // 「サイズ選択」を選んでいるのに、表示対象サイズが未選択になった場合は購入導線を無効化
            const selectedSizingValue = document.querySelector('input[name="sizing"]:checked')?.value;
            if (selectedSizingValue === 'サイズ選択') {
                const anySizeChecked = document.querySelector('input[name="size"]:checked');
                if (!anySizeChecked) {
                    sessionStorage.removeItem('selectedSize');
                    if (tabCompensation !== null && typeof nextButtonTabThird !== 'undefined' && nextButtonTabThird) {
                        nextButtonTabThird.disabled = true;
                    }
                    if (typeof checkoutButton !== 'undefined' && checkoutButton) {
                        checkoutButton.classList.add('disabled');
                    }
                }
            }
        }

        // ------------ カラーの在庫状況チェック機能 ------------
        // 各カラーについて、サイジングキット以外のサイズが全て在庫切れかチェックする関数
        function updateColorAvailability() {
            const colorRadios = document.querySelectorAll("input[name='color']");
            const sizeRadios = document.querySelectorAll("input[name='size']");
            
            colorRadios.forEach(colorRadio => {
                const colorValue = colorRadio.value;
                const colorLabel = colorRadio.closest('.p-radio');

                if (!colorLabel) return;
                
                // 既存のSOLD OUTオーバーレイがあれば削除
                const existingOverlay = colorLabel.querySelector('.soldout-overlay');
                if (existingOverlay) {
                    existingOverlay.remove();
                }
                
                // このカラーに「存在する」サイズのみを対象に在庫状況をチェック
                const relevantSizes = Array.from(sizeRadios)
                    .map(r => r.value)
                    .filter(sizeValue => variantMainData.some(v => v.option1 === colorValue && v.option2 === sizeValue));

                const allSizesOutOfStock = relevantSizes.length === 0
                    ? true
                    : relevantSizes.every(sizeValue => {
                        const stockStatus = checkVariantAvailability(colorValue, sizeValue);
                        // 在庫切れまたは販売無効の場合はtrue
                        return !stockStatus.available || stockStatus.saleDisable;
                    });
                
                if (allSizesOutOfStock) {
                    // 全サイズ在庫切れの場合
                    colorRadio.disabled = true;
                    colorLabel.classList.add('is-soldout');

                    // 表示するオーバーレイ文言を決定
                    //  - SKUごとに soldout_button_text がある場合は、それをできるだけ反映
                    //  - ただし、同じカラー配下で文言が混在する場合は汎用の "SOLD OUT" を表示
                    let overlayText = 'SOLD OUT';
                    if (relevantSizes.length > 0) {
                        const texts = relevantSizes
                            .map(sizeValue => {
                                const st = checkVariantAvailability(colorValue, sizeValue);
                                return String(st.soldOutText || '').trim();
                            })
                            .filter(Boolean);

                        const uniqueTexts = Array.from(new Set(texts));
                        if (uniqueTexts.length === 1) {
                            overlayText = uniqueTexts[0];
                        }
                    }
                    
                    // SOLD OUTオーバーレイを作成
                    const soldOutOverlay = document.createElement('div');
                    soldOutOverlay.classList.add('soldout-overlay');
                    soldOutOverlay.innerHTML = String(overlayText).replace(/\n/g, '<br>');
                    colorLabel.appendChild(soldOutOverlay);
                } else {
                    // 在庫があるサイズが1つでもある場合
                    colorRadio.disabled = false;
                    colorLabel.classList.remove('is-soldout');
                }
            });

            // 「サイズ選択」表示中に、選べるサイズが未選択になった場合は購入導線を無効化
            const selectedSizing = document.querySelector('input[name="sizing"]:checked')?.value;
            if (selectedSizing === 'サイズ選択') {
                const anySizeChecked = document.querySelector('input[name="size"]:checked');
                if (!anySizeChecked) {
                    sessionStorage.removeItem('selectedSize');
                    if (typeof nextButtonTabThird !== 'undefined' && nextButtonTabThird) {
                        nextButtonTabThird.disabled = true;
                    }
                    if (typeof checkoutButton !== 'undefined' && checkoutButton) {
                        checkoutButton.classList.add('disabled');
                    }
                    if (typeof fixedCheckoutButton !== 'undefined' && fixedCheckoutButton) {
                        fixedCheckoutButton.style.display = 'none';
                    }
                    if (typeof fixedBtn !== 'undefined' && fixedBtn) {
                        fixedBtn.style.display = 'block';
                    }
                }
            }
        }

        // バリエーションの在庫状況をチェックする関数
        function checkVariantAvailability(colorValue, sizeValue) {
            // return variantMainData.some(variant => 
            //     variant.option1 === colorValue && 
            //     variant.option2 === sizeValue && 
            //     variant.available === true
            // );
            const variant = variantMainData.find(variant => 
                variant.option1 === colorValue && 
                variant.option2 === sizeValue
            );
            
            if (!variant) {
                return { 
                    available: false, 
                    soldOutText: 'Sold Out', // バリアントが見つからない場合のデフォルト値
                    saleDisable: false
                };
            }
            
            let soldOutText = 'Sold Out';

            if (variant.soldout_button_text) {
                // オブジェクトの場合は .value プロパティを取得
                if (typeof variant.soldout_button_text === 'object' && variant.soldout_button_text !== null) {
                    soldOutText = variant.soldout_button_text.value || 'Sold Out';
                }
                // 文字列の場合はそのまま使用
                else if (typeof variant.soldout_button_text === 'string') {
                    soldOutText = variant.soldout_button_text;
                }
            }

            return {
                available: variant.available,
                soldOutText: soldOutText, // メタフィールドから取得、なければデフォルト
                saleDisable: variant.sale_disable || false // 販売無効フラグ
            };
        }

        // ページロード時にも実行（ブラウザバック対応）
        window.addEventListener('load', function() {
            const selectedColor = document.querySelector('input[name="color"]:checked');
            if (selectedColor) {
                updateSizeAvailability();
                updateColorAvailability();
                updateSizeNoteVisibility();
            }
        });


        // ------------ 画像と連動 ------------ 
        // function moveSlide(target) {
        //     let slideId = target.getAttribute('data-slide-id'); // ボタンの `data-slide-id` を取得
        //     // console.log("選択したボタンのスライドデータID：", slideId);

        //     // 1️⃣ `data-slide-id` が一致する `.swiper-slide` を検索
        //     let slides = document.querySelectorAll(".swiper-slide");
        //     let matchedSlide = Array.from(slides).find(slide => slide.getAttribute("data-slide-id") === slideId);

        //     if (matchedSlide) {
        //         // 2️⃣ 一致するスライドのインデックスを取得
        //         let slideIndex = Array.from(slides).indexOf(matchedSlide);

        //         if (slideIndex !== -1) {
        //             // console.log(`スライド移動: ${slideId} -> Index: ${slideIndex}`);
        //             mySwiper_main.slideTo(slideIndex - 0, 500); // 500msでスライドを移動
        //         } else {
        //             // console.error("対応するスライドのインデックスが見つかりません");
        //         }
        //     } else {
        //         // console.error("ラジオボタンに対応するスライドが見つかりません");
        //     }
        // }
        function moveSlide(target) {
            let slideId = target.getAttribute('data-slide-id');
            
            // 1. 該当する画像要素を直接検索
            let targetImg = document.querySelector(`img[src*="${slideId}"], img[data-media-id="${slideId}"]`);
            
            if (targetImg) {
                // 2. その画像が属するスライドを取得
                let targetSlide = targetImg.closest('.swiper-slide');
                
                if (targetSlide) {
                    // 3. そのスライドのインデックスを取得
                    let allSlides = document.querySelectorAll('.swiper-slide');
                    let slideIndex = Array.from(allSlides).indexOf(targetSlide);
                    
                    // console.log(`画像から特定したスライドインデックス: ${slideIndex}`);
                    mySwiper_main.slideTo(slideIndex, 500);
                    return;
                }
            }
            
            console.error("画像ベースの検索でも見つかりませんでした");
        }

        // ------------ ボタンをクリックした時の関数 ------------ 
        function handleTabClick(targetTabId) {
            const currentTab = document.getElementById(targetTabId);
            const tab3 = document.getElementById("tab3");

            // 🔹 タブの切り替え
            document.querySelectorAll(".p-product__tab").forEach(tabBtn => tabBtn.classList.remove("is-active"));
            document.querySelector(`.p-product__tab[data-tab="${targetTabId}"]`).classList.add("is-active");

            // 🔹 タブコンテンツの切り替え
            document.querySelectorAll(".p-product__step").forEach(tab => tab.classList.remove("is-active"));
            if (currentTab) {
                currentTab.classList.add("is-active");
            }
            
            // デフォルトでサイズ表示or非表示
            if (targetTabId === "tab2") {
                const tab2El = document.getElementById("tab2");
                const shouldOpen =
                tab2El && tab2El.dataset && tab2El.dataset.openSizeOnTab === "true";

                // 設定がONならサイズ一覧を強制表示（サイジングのラジオは変更しない）
                if (shouldOpen && typeof sizeRadiosId !== "undefined" && sizeRadiosId) {
                sizeRadiosId.style.display = "block";
                }
            }

            document.querySelectorAll(`.p-product__contents`).forEach(tabContent => tabContent.classList.remove("is-active"));
            document.querySelectorAll(`.p-product__contents[data-tab="${targetTabId}"]`).forEach(tabContent => tabContent.classList.add("is-active"));
            // console.log(tab3);
            if(!tab3){
                if(targetTabId == "tab2"){
                    nextButtonTabSecond.style.display = "none";
                    checkoutButton.style.display = "block";
                    resetButton.style.display = "block";
                }
            }
        }


        // ------------ バリエーションの値を保存 ------------ 
        function saveSelectionToStorage() {
            const selectedColor = document.querySelector('input[name="color"]:checked')?.value;
            let selectedSize = document.querySelector('input[name="sizing"]:checked')?.value;
            let selectedCompensation = document.querySelector('input[name="compensation"]:checked')?.value;
            // 「サイズ選択」が選ばれた場合、実際の選択したサイズ（sizing の値）を適用
            if (selectedSize === "サイズ選択") {
                const selectedSizing = document.querySelector('input[name="size"]:checked')?.value;
                if (selectedSizing) {
                    selectedSize = selectedSizing;
                } else {
                    // console.warn("サイズが未選択です。");
                    // return;
                }
            }

            if (selectedColor) sessionStorage.setItem("selectedColor", selectedColor);
            if (selectedSize) sessionStorage.setItem("selectedSize", selectedSize);
            if (selectedCompensation) sessionStorage.setItem("selectedCompensation", selectedCompensation);
        }
        


        // ------------ 購入URLの更新 ------------ 

        function updateCheckoutUrl() {
            // console.log("URLが更新されました");
            if (!checkoutButton) {
                // console.warn("チェックアウトボタンがまだ存在しません。");
                return;
            }

            const selectedColor = sessionStorage.getItem("selectedColor");
            const selectedSize = sessionStorage.getItem("selectedSize");
            const selectedCompensation = sessionStorage.getItem("selectedCompensation");
            let cartBaseUrl = `https://soxai.co.jp/cart`;
            let selectedVariant = variantMainData.find(v => v.option1 === selectedColor && v.option2 === selectedSize);
            let soldoutButtonText = selectedVariant?.soldout_button_text || 'Sold Out'; // メタフィールドを取得、なければデフォルト値
            let cartUrl = `${cartBaseUrl}/${selectedVariant.id}:1`;

            // console.log("URLの値", selectedVariant);
            // console.log("variantMainDataの中身:", variantMainData);
            // console.log("selectedSizeの中身:", selectedSize);
            // console.log("selectedColorの中身:", selectedColor);


            // if (!selectedVariant) {
            //     console.warn("対応するバリエーションが見つかりません。");
            //     return;
            // }

            // // 🔹 `compensation_product_id` を `#variant-data` から取得
            // const compensationProductElement = document.getElementById("compensation-product-id");
            // const compensationProductId = compensationProductElement ? compensationProductElement.textContent.trim() : null;

            // // 🔹 `selectedCompensation` が "あり" の場合、補償商品を追加
            // if (selectedCompensation === "あり" && compensationProductId) {
            //     cartUrl += `,${compensationProductId}:1`;
            // }

            checkoutButton.href = cartUrl;
            fixedCheckoutButton.href = cartUrl;
            // console.log("チェックアウトURL更新:", cartUrl);
        }



        // ------------ リセット関数 ------------ 
        function resetColorRadios() {
            colorRadios.forEach(radio => {
                radio.checked = false;
            });
            sessionStorage.removeItem("selectedColor");
            // 最初の有効なカラーを選択
            const firstAvailableColor = Array.from(colorRadios).find(radio => !radio.disabled);
            if (firstAvailableColor) {
                firstAvailableColor.checked = true;
                moveSlide(firstAvailableColor);
                updateSizeAvailability();
                saveSelectionToStorage();
            }
        }
        function resetSizingRadios() {
            sizingRadios.forEach(radio => {
                radio.checked = false;
            });
            sessionStorage.removeItem("selectedSize");
        }
        function resetSizeRadios() {
            sizeRadios.forEach(radio => {
                radio.checked = false;
            });
            sessionStorage.removeItem("selectedSize");
        }
        function resetCompensationRadios() {
            compensationRadios.forEach(radio => {
                radio.checked = false;
            });
            sessionStorage.removeItem("selectedCompensation");
        }

        function resetAll() {
            // console.log("リセット！！");

            // タブの切り替え
            document.querySelectorAll(".p-product__tab").forEach(tabBtn => tabBtn.classList.remove("is-active"));
            document.querySelector(`.p-product__tab[data-tab="tab1"]`).classList.add("is-active");

            // コンテンツの切り替え
            document.querySelectorAll(".p-product__step").forEach(tab => tab.classList.remove("is-active"));
            tabColor.classList.add("is-active");

            document.querySelectorAll(`.p-product__contents`).forEach(tabContent => tabContent.classList.remove("is-active"));
            document.querySelectorAll(`.p-product__contents[data-tab="tab1"]`).forEach(tabContent => tabContent.classList.add("is-active"));

            // radio選択肢初期化
            resetColorRadios();
            resetSizingRadios();
            resetSizeRadios();
            resetCompensationRadios();
            changePrice();
            updateSizeNoteVisibility();
            sizeRadiosId.style.display = "none";

            // ボタンの切り替え
            resetButton.style.display = "none";
            checkoutButton.style.display = "none";
            nextButtonTabSecond.style.display = "block";
            fixedBtn.style.display = 'block';
            fixedBtn.innerText = 'カラー選択に戻る'
            fixedCheckoutButton.style.display = 'none';
            selectedColorValue.style.display = 'none'

            // ボタンを無効化
            // nextButtonTabSecond.disabled = true;
            nextButtonTabThird.disabled = true;
            checkoutButton.classList.add("disabled");

            // 購入ボタンURLの初期化
            let cartUrl = `https://soxai.co.jp/cart`;
            checkoutButton.href = cartUrl;

            // console.log("リセット完了: サイズ選択、タブの `is-active` を初期化し、ボタンをサイズ選択に進むに戻しました！");
        }

        // ------------ ブラウザバック ------------ 
        window.addEventListener('pageshow', function(event) {
            // bfcache から復元された場合 (ブラウザバックの場合)
            if (event.persisted) {
                // console.log("ブラウザキャッシュから復元されました (ブラウザバック検知)");
                restoreSelectionFromStorage();
            } else {
                // 通常のページロード時も状態を確認
                // console.log("通常のページロード");
                if (sessionStorage.getItem("selectedColor") || sessionStorage.getItem("selectedSize")) {
                    // console.log("保存された状態が見つかりました");
                    restoreSelectionFromStorage();
                }
            }
        });

        // 状態を復元する関数
        function restoreSelectionFromStorage() {
            // console.log("状態を復元します...");
            
            // タブコンテンツ取得
            const tabColor = document.getElementById("tab1");
            const tabSize = document.getElementById("tab2");
            const tabCompensation = document.getElementById("tab3");

            // オプション選択取得
            const colorRadios = document.querySelectorAll("input[name='color']");
            const sizingRadios = document.querySelectorAll("input[name='sizing']");
            const sizeRadiosId = document.getElementById("size");
            const sizeRadios = document.querySelectorAll("input[name='size']");
            const compensationRadios = document.querySelectorAll("input[name='compensation']");

            // ボタン取得
            const buttonContainer = document.getElementById("next-btn-container");
            const nextButtonTabSecond = document.getElementById("next-btn-tab2");
            const nextButtonTabThird = document.getElementById("next-btn-tab3");
            const checkoutButton = document.getElementById("checkout-btn");
            const resetButton = document.getElementById("reset-btn");
            const fixedBtn = document.getElementById("p-fixed-btn");
            const fixedCheckoutButton = document.getElementById("p-fixed-checkout-btn");
            
            const selectedColor = sessionStorage.getItem("selectedColor");
            const selectedSize = sessionStorage.getItem("selectedSize");
            const selectedCompensation = sessionStorage.getItem("selectedCompensation");
            
            // console.log("復元する値:", { selectedColor, selectedSize, selectedCompensation });
            
            // カラーの復元
            if (selectedColor) {
                const colorRadio = Array.from(colorRadios).find(radio => radio.value === selectedColor);
                if (colorRadio) {
                    colorRadio.checked = true;
                    // ボタンを有効化
                    nextButtonTabSecond.disabled = false;
                    
                    // 対応する画像を表示
                    moveSlide(colorRadio);
                }
            }
            
            // サイズの復元 (sizing または size)
            if (selectedSize) {
                // console.log("復元するサイズ:", selectedSize);
                // まず、sizingRadiosで一致するものを探す
                let sizingRadio = Array.from(sizingRadios).find(radio => radio.value === selectedSize);
                // console.log("sizingRadio で見つかった:", sizingRadio);
                
                if (sizingRadio) {
                    sizingRadio.checked = true;
                    
                    if (tabCompensation !== null) {
                        nextButtonTabThird.disabled = false;
                        if (selectedSize !== "サイズ選択") {
                            sizeRadiosId.style.display = "none";
                        }else{
                            sizeRadiosId.style.display = "block";
                        }
                    } else {
                        if (selectedSize !== "サイズ選択") {
                            checkoutButton.classList.remove("disabled");
                            sizeRadiosId.style.display = "none";
                        }else{
                            sizeRadiosId.style.display = "block";
                        }
                    }
                } else {
                    // sizingRadiosに一致するものがなければ、sizeRadiosをチェック
                    if (selectedSize !== "サイズ選択") {
                        // console.log("selectedSize は 'サイズ選択' ではない:", selectedSize);
                        // サイズ選択ラジオボタンを選択
                        const sizeSelectionRadio = Array.from(sizingRadios).find(radio => radio.value === "サイズ選択");
                        // console.log("sizeSelectionRadio を検索:", sizeSelectionRadio);
                        if (sizeSelectionRadio) {
                            console.log("sizeSelectionRadio をチェック");
                            sizeSelectionRadio.checked = true;
                            sizeRadiosId.style.display = "block";
                        }
                        
                        // 実際のサイズラジオボタンを選択
                        const sizeRadio = Array.from(sizeRadios).find(radio => radio.value === selectedSize);
                        if (sizeRadio) {
                            sizeRadio.checked = true;
                            
                            if (tabCompensation !== null) {
                                nextButtonTabThird.disabled = false;
                            } else {
                                checkoutButton.classList.remove("disabled");
                            }
                        }
                    }
                }
            }
            changePrice();
            updateSizeNoteVisibility();
            // 補償の復元
            if (selectedCompensation && compensationRadios.length > 0) {
                const compensationRadio = Array.from(compensationRadios).find(radio => radio.value === selectedCompensation);
                if (compensationRadio) {
                    compensationRadio.checked = true;
                    checkoutButton.classList.remove("disabled");
                }
            }
            
            // もしカラーとサイズの両方が選択されていれば、サイズ選択タブに移動
            if (selectedColor && selectedSize) {
                // タブ2（サイズ選択）に切り替え
                handleTabClick("tab2");
                if (fixedBtn) fixedBtn.textContent = 'サイズ選択に戻る';
                selectedColorValue.style.display = 'flex';
                // サイズ選択が「サイズ選択」でない場合はチェックアウトボタンを表示
                if (selectedSize !== "サイズ選択") {
                    if (tabCompensation !== null && selectedCompensation) {
                        // 補償タブがあり、補償も選択済みの場合は補償タブへ
                        handleTabClick("tab3");
                        nextButtonTabSecond.style.display = "none";
                        checkoutButton.style.display = "block";
                        resetButton.style.display = "block";
                        if (fixedBtn) fixedBtn.style.display = 'none';
                        if (fixedCheckoutButton) fixedCheckoutButton.style.display = 'block';
                    } else if (!tabCompensation) {
                        // 補償タブがない場合はチェックアウトボタンを表示
                        nextButtonTabSecond.style.display = "none";
                        checkoutButton.style.display = "block";
                        resetButton.style.display = "block";
                        if (fixedBtn) fixedBtn.style.display = 'none';
                        if (fixedCheckoutButton) fixedCheckoutButton.style.display = 'block';
                    }
                }
                
                // 購入URLを更新
                updateCheckoutUrl();
            }
        }
    }
    initializeProductSelection();
    document.addEventListener("shopify:section:load", function () {
        initializeProductSelection();
    });
});
// 色選択によって価格を動的に更新する関数
// document.addEventListener("DOMContentLoaded", function() {
//     function changePrice() {
//         // 価格表示要素
//         const mainPriceElement = document.querySelector('.p-product__main-price');
//         const beforePriceElement = document.querySelector('.p-product__before-price');
        
//         // カラーラジオボタン
//         const colorRadios = document.querySelectorAll('input[name="color"]');
        
//         // 各カラーラジオボタンにイベントリスナーを追加
//         colorRadios.forEach(radio => {
//         radio.addEventListener('change', updateProductPrice);
//         });
        
//         // 初期読み込み時に選択されているカラーの価格を設定
//         const initialSelectedColor = document.querySelector('input[name="color"]:checked');
//         if (initialSelectedColor) {
//         updateProductPrice({ target: initialSelectedColor });
//         }
        
//         // 価格更新関数
//         function updateProductPrice(event) {
//         // 選択されたラジオボタン
//         const selectedRadio = event.target;
        
//         // 対応する価格要素を取得
//         const priceContainer = selectedRadio.closest('.p-radio').querySelector('.p-radio__price');
        
//         if (priceContainer) {
//             // 通常価格と割引価格の取得
//             const salePrice = priceContainer.querySelector('.sale-price');
//             const linePrice = priceContainer.querySelector('.line-price');
//             const regularPrice = priceContainer.querySelector('.p-radio__after-price:not(.sale-price):not(.line-price)');
            
//             // 価格表示の更新
//             if (salePrice && linePrice) {
//             // 割引がある場合
//             mainPriceElement.innerHTML = salePrice.innerHTML;
//             beforePriceElement.style.display = 'block';
//             beforePriceElement.innerHTML = `<s>${linePrice.innerHTML}</s>`;
//             } else if (regularPrice) {
//             // 割引がない場合
//             mainPriceElement.innerHTML = regularPrice.innerHTML;
//             beforePriceElement.style.display = 'none';
//             }
//         }
//         }
//     }
//     changePrice();
//     document.addEventListener("shopify:section:load", function () {
//         changePrice();
//     });
//   });

// ================================================================
// タブ
// ================================================================
document.addEventListener('DOMContentLoaded', function() {
    function changeTab() {
    // 監視対象の要素
    const nextBtnContainer = document.getElementById('next-btn-container');
    const fixedBtnContainer = document.querySelector('.p-fixed-btn');

    // next-btn-containerが存在する場合のみ処理を実行
    if (nextBtnContainer && fixedBtnContainer) {
        // 初期状態では非表示
        fixedBtnContainer.style.display = 'none';
        
        // スクロールイベントのハンドラー
        function handleScroll() {
        // next-btn-containerの位置情報を取得
        const nextBtnRect = nextBtnContainer.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const nextBtnPosition = nextBtnRect.top + scrollTop;
        
        // 現在のスクロール位置
        const currentScrollPosition = window.scrollY;
        
        // 条件1: next-btn-containerが画面内に見えていない
        // 条件2: 現在のスクロール位置がnext-btn-containerよりも下にある
        if (nextBtnRect.bottom < 0 && currentScrollPosition > nextBtnPosition) {
            fixedBtnContainer.style.display = 'block';
        } else {
            fixedBtnContainer.style.display = 'none';
        }
        }
        
        // スクロールイベントをリスナーに追加
        window.addEventListener('scroll', handleScroll);
        
        // 初期状態の確認
        handleScroll();
        
        // Intersection Observerも併用して確実に検知
        const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // 非表示になった場合はスクロール位置もチェック
            if (!entry.isIntersecting) {
            handleScroll();
            } else {
            // 表示されている場合は確実に非表示
            fixedBtnContainer.style.display = 'none';
            }
        });
        }, {
        threshold: 0
        });
        
        // 監視開始
        observer.observe(nextBtnContainer);
        }
    }
    changeTab();
    document.addEventListener("shopify:section:load", function () {
        changeTab();
    });
});


// ================================================================
// 時間での割引価格制御
// ================================================================
// document.addEventListener('DOMContentLoaded', function () {
//     const nowDate = new Date();
//     // nowを2025-07-23-16:00フォーマットに変換
//     const now = nowDate.getFullYear() + '-' + 
//                 String(nowDate.getMonth() + 1).padStart(2, '0') + '-' + 
//                 String(nowDate.getDate()).padStart(2, '0') + '-' + 
//                 String(nowDate.getHours()).padStart(2, '0') + ':' + 
//                 String(nowDate.getMinutes()).padStart(2, '0');
    
//     const product_piriod = document.querySelector('.product-form__input .value');
//     const start = product_piriod.dataset.start;
//     const end = product_piriod.dataset.end;

//     if ((start && now < start) || (end && now > end)) {
//       console.log('表示期間外');
//     }else{
//     console.log('表示期間です');
//     }
//     // sliderItems.forEach(item => {
//     // });
//     console.log('現在時刻：',now);
//     console.log('販売開始：',start);
//     console.log('販売終了：',end);
//   });



document.addEventListener('DOMContentLoaded', function () {
    const nowDate = new Date();
    // nowを2025-07-23-16:00フォーマットに変換
    const now = nowDate.getFullYear() + '-' + 
                String(nowDate.getMonth() + 1).padStart(2, '0') + '-' + 
                String(nowDate.getDate()).padStart(2, '0') + '-' + 
                String(nowDate.getHours()).padStart(2, '0') + ':' + 
                String(nowDate.getMinutes()).padStart(2, '0');
    
    const product_piriod = document.querySelector('.product-form__input .value');
    const start = product_piriod.dataset.start;
    const end = product_piriod.dataset.end;

    // 価格表示を更新
    document.querySelectorAll('.p-radio__price--color').forEach(priceContainer => {
        const normalPrice = priceContainer.dataset.normalPrice;
        const discountPrice = priceContainer.dataset.discountPrice;
        console.log("通常料金",normalPrice);
        console.log("割引料金",discountPrice);
        if ((start && now < start) || (end && now > end)) {
            // 表示期間外 - 通常価格のみ
            priceContainer.innerHTML = `<p class="p-radio__after-price"><span>¥</span>${normalPrice}</p>`;
            console.log('表示期間外');
        } else {
            if(discountPrice != 0 && discountPrice < normalPrice){
                // 表示期間内 - 割引価格
                priceContainer.innerHTML = `
                    <p class="p-radio__after-price line-price"><span>¥</span>${normalPrice}</p>
                    <p class="p-radio__after-price sale-price"><span class="dli-caret-right pc-hide"></span><span>¥</span>${discountPrice}</p>
                `;
                console.log('表示期間です');
            }else{
                priceContainer.innerHTML = `<p class="p-radio__after-price"><span>¥</span>${normalPrice}</p>`;
            }
        }
    });
    
    console.log('現在時刻：',now);
    console.log('販売開始：',start);
    console.log('販売終了：',end);
});


// ================================================================
// リセット
// ================================================================
// document.getElementById("reset-btn").addEventListener("click", function () {
//     location.reload();
// });




// ================================================================
// 375px以下でviewport変更
// ================================================================

!(function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    function switchViewport() {
        const value =
            window.outerWidth > 375
                ? 'width=device-width,initial-scale=1'
                : 'width=375';
        if (viewport.getAttribute('content') !== value) {
            viewport.setAttribute('content', value);
        }
    }
    addEventListener('resize', switchViewport, false);
    switchViewport();
})();
